/**
 * @file: getPyInitials.ts
 * @copyright: (c) 2019-2026 sichuan zhichetech co., ltd.
 */

let map: Map<string, string> | undefined = undefined;

/**
 * Build a search-friendly initials string from `word`:
 * - Chinese characters → the pinyin initial of the character (lowercase, e.g.
 *   "按" → "a").
 * - Latin letters and digits are passed through unchanged so mixed strings
 *   like "MMI按键A错误" produce "MMIajAcw" (callers typically lowercase the
 *   result for case-insensitive matching).
 * - Any other character (punctuation, whitespace, …) is dropped.
 */
export function getPyInitials(word: string) {
  if (map == null) {
    map = new Map<string, string>();
    const data = require('./dict.json') as { [p: string]: string };
    for (const p in data) {
      const initial = p.charAt(0);
      const chars = data[p].split('');
      for (const char of chars) {
        map.set(char, initial);
      }
    }
  }
  const out: string[] = [];
  for (const char of word) {
    const initial = map.get(char);
    if (initial != null) {
      out.push(initial);
    } else if (/^[a-zA-Z0-9]$/.test(char)) {
      out.push(char);
    }
  }
  return out.join('');
}
